import { z } from "zod";
import { schemaRawAccount } from "../../accounts";
const schemaAccountListParams = z
    .object({
    currencyIds: z.array(z.string()).optional(),
})
    .optional();
const schemaAccountListResults = z.object({
    rawAccounts: z.array(schemaRawAccount),
});
export const schemaAccountList = {
    params: schemaAccountListParams,
    result: schemaAccountListResults,
};
//# sourceMappingURL=AccountList.js.map